module.exports = __webpack_public_path__ + "img/laptop.67e6614b.png";